import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

const Info = ({ size, color, theme, iconTitle }) => {
  const iconColor = color || (theme && theme.iconColor);
  return (
    <svg
      viewBox="0 0 16 17"
      width={size}
      height={size}
      color={iconColor}
      fill={iconColor}
    >
      <title>{iconTitle}</title>
      <defs>
        <path d="M8.6,10.7399194 L7.04418605,10.7399194 C7.04883723,10.2815837 7.08604616,9.89594691 7.15581395,9.58299731 C7.22558174,9.27004772 7.34302243,8.98544035 7.50813953,8.72916667 C7.67325664,8.47289298 7.89302188,8.20183835 8.16744186,7.91599462 C8.38139642,7.69914766 8.57441774,7.49339255 8.74651163,7.29872312 C8.91860551,7.10405369 9.05581344,6.89706651 9.15813953,6.67775538 C9.26046563,6.45844424 9.31162791,6.2058706 9.31162791,5.92002688 C9.31162791,5.60954146 9.26279119,5.34587922 9.16511628,5.12903226 C9.06744137,4.9121853 8.92441955,4.74708838 8.73604651,4.63373656 C8.54767348,4.52038474 8.31395488,4.46370968 8.03488372,4.46370968 C7.80232442,4.46370968 7.58372195,4.51176027 7.37906977,4.6078629 C7.17441758,4.70396553 7.00930295,4.85181352 6.88372093,5.05141129 C6.75813891,5.25100906 6.69069772,5.51343923 6.68139535,5.83870968 L5,5.83870968 C5.00930237,5.21773883 5.14883586,4.69534262 5.41860465,4.27150538 C5.68837344,3.84766813 6.05116051,3.52979497 6.50697674,3.31787634 C6.96279298,3.10595772 7.47209021,3 8.03488372,3 C8.65814265,3 9.19069547,3.11211805 9.63255814,3.33635753 C10.0744208,3.560597 10.4127895,3.88586256 10.6476744,4.31216398 C10.8825593,4.73846539 11,5.25223714 11,5.85349462 C11,6.28718855 10.9186055,6.68021777 10.755814,7.03259409 C10.5930224,7.3849704 10.3813967,7.7127001 10.1209302,8.01579301 C9.86046381,8.31888592 9.57907128,8.62074222 9.27674419,8.92137097 C9.01627777,9.17271631 8.83953535,9.44500301 8.74651163,9.73823925 C8.65348791,10.0314755 8.60465119,10.3653655 8.6,10.7399194 Z M6.90465116,13.046371 C6.90465116,12.7802406 6.99069681,12.5547724 7.1627907,12.3699597 C7.33488458,12.1851469 7.56976595,12.0927419 7.86744186,12.0927419 C8.16511777,12.0927419 8.39999914,12.1851469 8.57209302,12.3699597 C8.74418691,12.5547724 8.83023256,12.7802406 8.83023256,13.046371 C8.83023256,13.3125013 8.74418691,13.5379695 8.57209302,13.7227823 C8.39999914,13.907595 8.16511777,14 7.86744186,14 C7.56976595,14 7.33488458,13.907595 7.1627907,13.7227823 C6.99069681,13.5379695 6.90465116,13.3125013 6.90465116,13.046371 Z"></path>
      </defs>
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g>
          <ellipse fill="#A28352" cx="8" cy="8.5" rx="8" ry="8.5"></ellipse>
          <g fill-rule="nonzero"></g>
        </g>
      </g>
    </svg>
  );
};

Info.propTypes = {
  color: PropTypes.string,
  iconTitle: PropTypes.string,
  size: PropTypes.number,
  theme: PropTypes.object,
};

Info.defaultProps = {
  color: null,
  iconTitle: null,
  size: 26,
  theme: null,
};

export default withTheme(Info);
